import { Box, Container, Flex, HStack, Text, useTheme } from "@chakra-ui/react";
import { ReactComponent as UscssLogo } from "../assets/SafeSportLogo_PrimaryLogo.svg";

type HeaderBarProps = {
  nowDate: string;
};

function formatLastUpdated(value: string): string {
  if (!value) return "—";

  // The API currently provides timestamps in this explicit UTC format.
  const match = value.match(
    /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2}) UTC$/,
  );
  if (!match) return value;

  const [, month, day, year, hour, minute, second] = match;
  const timestamp = new Date(
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second),
    ),
  );

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
  }).format(timestamp);
}

export default function HeaderBar({ nowDate }: HeaderBarProps) {
  const theme = useTheme();
  const navy900 = (theme.colors as any)?.navy?.[900] || "#182638";

  return (
    <Box
      as="header"
      bg="gray.100"
      color={navy900}
      borderBottom="1px solid"
      borderColor="gray.200"
      py={3}
    >
      <Container maxW="96rem" px={{ base: 4, md: 6, xl: 8 }}>
        <Flex
          direction={{ base: "column", md: "row" }}
          align={{ base: "flex-start", md: "center" }}
          justify="space-between"
          gap={3}
        >
          <HStack spacing={3} align="center">
            <UscssLogo style={{ height: "40px", width: "auto" }} />

            <Text
              as="span"
              fontSize="sm"
              fontWeight="bold"
              letterSpacing="wide"
              color={navy900}
            >
              Centralized Disciplinary Database
            </Text>
          </HStack>

          <Text
            fontSize="xs"
            color="gray.700"
            fontWeight="semibold"
            textAlign={{ base: "left", md: "right" }}
          >
            <Text as="span" fontWeight="bold" color={navy900}>
              Last Updated:
            </Text>{" "}
            {formatLastUpdated(nowDate)}
          </Text>
        </Flex>
      </Container>
    </Box>
  );
}
